import React, { ReactNode, SyntheticEvent, useCallback, useMemo } from 'react'
import { IconButton } from '@cargomart/ui'
import { IconSpinner } from 'components/IconSpinner'
import { IconTooltipError } from 'components/IconTooltip'
import IconArrowDown from 'remixicon/icons/Arrows/arrow-down-s-line.svg?react'
import IconClear from 'remixicon/icons/System/close-line.svg?react'

export interface IAsyncSelectPostfix {
  error?: string | boolean
  handleClear?: () => void
  handleClose?: () => void
  hasDropDownIcon?: boolean
  hasOption?: boolean
  isClearable?: boolean
  isDisabled?: boolean
  isLoading?: boolean
  isOpen?: boolean
  postfix?: ReactNode
}

export const DefaultSelectPostfix = ({
  isLoading,
  isDisabled,
  hasOption,
  handleClear,
  hasDropDownIcon,
  isClearable,
  error,
  postfix,
  isOpen,
  handleClose
}: IAsyncSelectPostfix) => {
  const onClear = useCallback(
    (e: SyntheticEvent<HTMLButtonElement>) => {
      e.stopPropagation()
      handleClear?.()
    },
    [handleClear]
  )
  const onClose = useCallback(() => {
    if (isOpen) {
      handleClose?.()
    }
  }, [handleClose, isOpen])

  const renderPostfix = useMemo(() => {
    if (isLoading) {
      return <IconSpinner />
    }

    if (isClearable && hasOption && !isDisabled) {
      return (
        <IconButton onClick={onClear} size="sm">
          <IconClear className="text-on-surface-variant" />
        </IconButton>
      )
    }

    if (typeof error === 'string') {
      return <IconTooltipError>{error}</IconTooltipError>
    }

    return null
  }, [isLoading, isClearable, hasOption, isDisabled, error, onClear])

  return (
    <div className="flex items-center">
      {postfix}
      {renderPostfix}
      {hasDropDownIcon && (
        <IconArrowDown
          className="cursor-pointer text-on-surface-variant transition"
          onClick={onClose}
          rotate={isOpen ? 180 : 0}
        />
      )}
    </div>
  )
}
